import {createAction} from "@reduxjs/toolkit";
import {PipelineFlowTransportSearchCriteria} from "@ots-frontend/ots-data";

export const setUIPipelineFlowTransportSearchFilter = createAction<PipelineFlowTransportSearchCriteria>("ots-ui/pipeline-flow-transport/setSearchFilter");
